import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { RichTextSection } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const messages = defineMessages({
  lang: {
    id: 'pubblicazione_publication_lang',
    defaultMessage: 'Lingua della pubblicazione',
  },
});

const PubblicazioneLingua = ({ content }) => {
  const intl = useIntl();

  return content?.publicationLanguage ? (
    <RichTextSection
      title={intl.formatMessage(messages.lang)}
      tag_id="publication_lang"
    >
      {content.publicationLanguage.title}
    </RichTextSection>
  ) : null;
};

export default PubblicazioneLingua;
